import { TEST_RIDE_FORM_LINKS_ENDPOINT } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
export async function getLinksForTestRide({ currentPath }) {
    const response = await Network.get(TEST_RIDE_FORM_LINKS_ENDPOINT, {
        params: {
            path: currentPath,
        },
    });
    return response.data;
}
